import React from "reactn"
import { graphql } from "gatsby"
import { ColumnCardData } from "./column-card-data";
import { Box } from "@chakra-ui/layout";

export function ColumnCard({ columnCard, eager }) {  
  return (
    <Box id="columnCard" >
      <ColumnCardData  isStory={false} eager={eager} columnCardData={columnCard}/>  
    </Box>  
  );
}

export const query = graphql`
  fragment ColumnCard on DatoCmsColumn {
    model { apiKey }
    id
    name
    title
    subtitle
    text
    button {
      text
      color
      style
      link {
        ... on DatoCmsSinglepage {
          id: originalId
          slug        
        }
        ... on DatoCmsProductgroup {
          id: originalId
          slug
        }
      }
    }
    image {
      alt
      title
      gatsbyImageData(
        placeholder: BLURRED,
        forceBlurhash: false,
        imgixParams: { invert: false }
      )
    }
  }
`
